

<div class="row padding-top link_logo pt36 margin-bottom mb8">
  <div class="col">
    <figure>
      <img src="./assets/img/images/expired.svg" alt="Otp" />
    </figure>
  </div>
</div>
<div class="row">
  <div class="col">
    <h1 class="title-copy text-center">
      {{ "LINK_EXPIRED_EMAIL" | translate }}
    </h1>
  </div>
</div>
<div class="row subText text-center">
  <div class="col">
    <p class="color-class">
      {{ "WE_CAN_SEND_YOU_VALIDATION_EMAIL" | translate }}
    </p>
  </div>
</div>

<div class="row subText text-center">
  <div class="col">
    <p class="color-class">{{ maskEmail }}</p>
  </div>
</div>

<div class="row group-button text-center mb10">
  <div class="col">
    <mapfre-button
      [additionalClasses]="'basic primary large-btn'"
      [translateValue]="'SEND_NEW_EMAIL' | translate"
      (click)="sendNewEmail()"
    >
      {{ "SEND_NEW_EMAIL" | translate }}
    </mapfre-button>
  </div>
</div>

<div class="row text-center">
  <div class="col">
    <p class="color-class">
      {{ "IF_YOU_DONT_RECEIVE_EMAIL_CONTACT_CUS_CARE" | translate }}
    </p>
  </div>
</div>
